// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewFooter-ReceiptTitle_cls1__Czw0f","cls2":"PaymentViewFooter-ReceiptTitle_cls2__d56Dj PaymentViewFooter-ReceiptTitle_cls1__Czw0f"};